import { useContext } from 'react';

import { HistogramInfiniteZoomContext } from '../providers/HistogramInfiniteZoom.context.js';

export const useInfiniteZoomConfig = () =>
  useContext(HistogramInfiniteZoomContext);
